import {
  getSubmissionsIcon,
  getSubmissionPillColors,
  getSubmissionStatusDisplayName
} from "@/Utils/Plan/PlanSubmissionsStatuses";
import { PlanSubmission, SubmissionStatus } from "@/Utils/Plan/PlanSubmisionsTypes";
import { Icon, Pill, TooltipWrapper } from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

type ApprovalStatusRendererProps = {
  submissionData?: PlanSubmission;
  onClick?: () => void;
  dataTestIdPrefix?: string;
};

const ApprovalStatusRenderer = ({
  submissionData,
  onClick,
  dataTestIdPrefix
}: ApprovalStatusRendererProps) => {
  const submissionStatus = submissionData?.status ?? SubmissionStatus.Draft;

  const displayStatus = getSubmissionStatusDisplayName(submissionStatus);

  const tooltipMessage =
    submissionStatus === SubmissionStatus.Draft
      ? appstr(
          "This plan is in draft and has no approver information available until it is submitted for approval."
        )
      : displayStatus;

  return (
    <TooltipWrapper
      tooltipProps={{
        message: tooltipMessage
      }}
      fitReferenceToContent
    >
      <Pill
        label={displayStatus}
        color={getSubmissionPillColors(submissionStatus)}
        leftContent={<Icon {...getSubmissionsIcon(submissionStatus)} size={"small"} />}
        className="ocn-plan-explorer-cell-pill ocn-plan-approval-status-pill"
        data-testid={
          dataTestIdPrefix
            ? `${dataTestIdPrefix}-approval-status-pill`
            : "plan-explorer-approval-status-pill"
        }
        onClick={onClick}
      />
    </TooltipWrapper>
  );
};

export default ApprovalStatusRenderer;
